// @core/api/endpoints/calendar/list_calendars.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListCalendarsResponse,
} from '../../../types/calendar';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/calendar';

/**
 * List calendars
 * Returns all calendars accessible to the current user including owned, shared, and subscribed calendars.
 */
export async function ListCalendars(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListCalendarsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/calendars`;
  const requestOptions = options;
  return client.get<ListCalendarsResponse>(requestPath, { ...requestOptions, params });
}
